import { useEffect, useState } from "react";
import { inject } from "mobx-react";
import { fetch } from "../../utils/api-wrapper";
import withRouter from '../../components/withRouter';
import uploadIcon from '../../assets/img/icon-upload.svg';
import uploadingIcon from '../../assets/img/icon-uploading.svg';
import uploadedIcon from '../../assets/img/icon-file-uploaded.svg';
import NewExpensesMobileInputs from "./new-expenses-mobile-inputs";
import UploadRefusalList, { uploadRefusalRow } from "../../components/upload-refusal-list";

const NewExpensesMobile = ({data, navigate, params}) => {
  const [isSaving, setIsSaving] = useState(false);
  const [isDone, setIsDone] = useState(false);
  const [filesSubmitted, setFilesSubmitted] = useState([]);
  const [errors, setErrors] = useState([]);

  useEffect(() => {
      data.hideMenu = true;
      return () => {
          data.hideMenu = false;
      }
  }, [data]);

  const accountId = params['account_id'];

  const saveExpenses = async (expenses) => {
    setIsSaving(true);
    const filesSaved = [];
    const savingErrors = [];

    await Promise.all(expenses.map(async expense => {
      const formData = new FormData();
      formData.append("image", expense.file);
      formData.append("description", expense.description);
      formData.append("is_billable", expense.isBillable);
      if (expense.isBillable) {
        formData.append("matter_id", expense.matterId);
      }

      await fetch(`/expenses_account/add/${accountId}`, "PUT", formData,
        () => filesSaved.push(expense.file.name),
        response => {
          // Keep the ?. : a network error has no response, and throwing here left the
          // screen on "Uploading" (XPEN-3590).
          savingErrors.push(uploadRefusalRow(data, expense.file.name, response?.response?.data, accountId));
        },
        true
      );
    }));
    
    setFilesSubmitted(filesSaved);
    setErrors(savingErrors);
    setIsSaving(false);
    setIsDone(true);
  }

  return (
    <div className="new-expenses-mobile">
      <div className="pointer position-absolute text-primary pointer" style={{right : 20, top : 20}} onClick={() => navigate(-1)}>
        {data.t.read("back")}
      </div>
      <div className="page-centered">
        <div className="upload-container p-3">
          { !isSaving && !isDone && (
            <div className="first-files-container">
              <div>
                <img src={uploadIcon} alt="upload" />
              </div>
              <div className="font-weight-bold mt-3">
                {data.t.read("upload_new_invoice")}
              </div>
              <div className="text-secondary mb-5">
                {data.t.read("take_picture")}
              </div>
              <NewExpensesMobileInputs data={data} saveExpenses={saveExpenses}/>
            </div>
          )}
          { isSaving && (
            <div className="uploading-container" data-testid="saving-indicator">
              <div>
                <img src={uploadingIcon} alt="Uploading" />
              </div>
              <div className="font-weight-bold font-large">
                {data.t.read("uploading")}
              </div>
            </div>
          )}
          { isDone && (
            <div className="uploading-container py-4">
              <div>
                <img src={uploadedIcon} alt="File Uploaded" />
              </div>
              <div className="font-weight-bold mt-3" data-testid="done-message">
                {filesSubmitted.length === 0 && errors.length > 0
                  ? data.t.read("expense_upload.error_none_added")
                  : data.t.read("upload_completed")}
              </div>
              { filesSubmitted.length > 0 && (
                <div className="text-secondary text-center" data-testid="files-submitted">
                  {data.t.read(filesSubmitted.length === 1 ? "expense_upload.receipts_added_one" : "expense_upload.receipts_added_other")}
                  {" " + filesSubmitted.join(", ")}
                </div>
              )}
              {/* XPEN-3618: just above Done, and a direct child of the card so it stretches to its width. */}
              {errors.length > 0 && <UploadRefusalList data={data} rows={errors} />}
              <div className="mt-4">
                <button className="btn btn-primary btn-cta text-center px-4" onClick={() => navigate(-1)}>
                  {data.t.read("done")}
                </button>
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}

export default inject("data")(withRouter(NewExpensesMobile));
